export default __webpack_public_path__ + "static/media/EESymbolsImg1.cfe74cc9.jpg";